import { FormatterCell } from "components/Table";

export const customTextAreaFormatter = (cell: FormatterCell) => {
	const { value } = cell;
	if (value) {
		const dummyElement = document.createElement('div');
		dummyElement.innerHTML = value;
		return dummyElement.innerText;
	}

	return ''
}
